import { Input, Form, Select, TreeSelect, FormInstance } from 'antd'
import React from 'react'
import { useUpdate } from 'react-use'

import CreatorSelect from '@/components/fields/creator-select'
import FunctionPermission from '@/components/permissions/function-permission'
import { FunctionKey } from '@/constants/function-key'
import { GroupType } from '@/model/group'
import { selectCreatorOptions } from '@/redux/creator-selector'
import { selectGroupTreeData } from '@/redux/group-selectors'
import { selectRoleOptions } from '@/redux/role-selectors'
import { createAppSelector, useAppSelector } from '@/redux/utils'
import filterOptionsWithStatus from '@/utils/filter-options'

const { Item } = Form

const selector = createAppSelector(
  [
    state => selectGroupTreeData(state, GroupType.Employee),
    selectRoleOptions,
    selectCreatorOptions,
  ],
  (groupOptions, rolesOptions, creatorOptions) => {
    return { groupOptions, rolesOptions, creatorOptions }
  },
)

export default function EmployeeFields({ form }: { form: FormInstance }) {
  const { groupOptions, rolesOptions } = useAppSelector(selector)

  // trigger re-render when roles change
  // and get latest roles values from form
  const forceUpdate = useUpdate()
  const rolesValues = form.getFieldValue('roleIds') as number[]

  return (
    <>
      <Item name="id" hidden />
      <Item
        name="name"
        label="Employee Name"
        required
        rules={[{ required: true }]}
      >
        <Input placeholder="Enter name" />
      </Item>
      <Item name="email" label="Email" required rules={[{ required: true }]}>
        <Input placeholder="Enter email address" />
      </Item>
      <Item name="groupId" label="Group" required rules={[{ required: true }]}>
        <TreeSelect<number>
          treeData={groupOptions}
          treeDefaultExpandAll
          allowClear
          placeholder="Select group"
        />
      </Item>
      <FunctionPermission functionKey={FunctionKey.EmployeesManageSetupRole}>
        <Item name="roleIds" label="Role" required rules={[{ required: true }]}>
          <Select
            mode="multiple"
            placeholder="Select role"
            options={filterOptionsWithStatus(rolesOptions, rolesValues)}
            onChange={forceUpdate}
            allowClear
          />
        </Item>
      </FunctionPermission>
      <FunctionPermission functionKey={FunctionKey.EmployeesManageAssignCreators}>
        <Item name="creatorIds" label={'Assign Creator(s)'}>
          <CreatorSelect />
        </Item>
      </FunctionPermission>
    </>
  )
}
